import { setFetchTasksEarnedStatus, setTasksEarnedAtPage } from "actions/jobs";
import { TASK_SPENT_PAGE_SIZE } from "constants/util";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.jobs.IFetchTasksEarned) {
    yield put(setFetchTasksEarnedStatus("loading", action.page));
    try {
        const response = yield post("/get-earned-tasks", {
            skip: TASK_SPENT_PAGE_SIZE * action.page,
            limit: TASK_SPENT_PAGE_SIZE,
        });
        if (response.data !== null) {
            yield put(setTasksEarnedAtPage(response.data, action.page));
            yield put(setFetchTasksEarnedStatus("none", action.page));
        } else {
            yield put(setFetchTasksEarnedStatus("error", action.page));
        }
    } catch (e) {
        yield handleNetworkError(e);
        yield put(setFetchTasksEarnedStatus("error", action.page));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.jobs.IFetchTasksEarned", execute);
}
